<!--
 * @Description: 总部署统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-17 17:59:26
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 11:15:03
 -->
<template>
  <div class="deployCount">
    <div class="regionItem" v-for="(item, index) in deployData.items" :key="index">
      <div>部署<span> {{item.projectCount}} </span>个</div>
      <div>使用<span> {{item.userCount}} </span>人</div>
      <div>{{item.region}}</div>
    </div>
    <div class="totalCount">
      <div>总部署<span> {{deployData.projectCount}} </span>个路段</div>
      <div>总使用<span> {{deployData.userCount}} </span>人</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deployCount',
  components: {
  },
  data () {
    return {
      deployData: {},
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @return {undefied}             无返回值
     */
    getData () {
      this.$http.get('/rest/screen/project/summary', {
        productCode: 'lwtsgz',
      })
        .then(res => {
          if (res.code === 0) {
            this.deployData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .deployCount {
    width: 100%;
    height: 100%;
    background: url('/static/img/layout/region.png');
    background-size: 100% 100%;
    position: relative;
    .regionItem {
      width: 18.5%;
      height: 20%;
      color: #fff;
      text-align: center;
      position: absolute;
      >div {
        font-size: 18px;
        margin: 6%;
        >span {
          color: #fff32f;
          font-weight: bold;
        }
        &:nth-of-type(3) {
          color: #01ffff;
          font-size: 20px;
          font-weight: bold;
          margin-top: 11%;
        }
      }
    }
    .regionItem:nth-of-type(1) {
      left: 7.9%;
      top: 10.3%;
    }
    .regionItem:nth-of-type(2) {
      left: 30.4%;
      top: 0.8%;
    }
    .regionItem:nth-of-type(3) {
      left: 52.8%;
      top: 0.8%;
    }
    .regionItem:nth-of-type(4) {
      left: 75.3%;
      top: 10.3%;
    }
    .totalCount {
      width: 100%;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 12%;
      font-size: 20px;
      color: #fff;
      >div{
        margin: 2%;
        >span {
          color: #fff32f;
          font-weight: bold;
        }
      }
    }
  }
</style>
